module.exports = __webpack_public_path__ + "img/pk.a9b736c3.png";